import React from 'react';
import './publicBase.css';
import './publicData.css';
import './publicTable.css';

export default function PublicShell({title,subtitle,freshness,children}){
  return <div className="pub-root">
    <header className="pub-top"><div className="pub-top-inner">
      <div><h1>{title}</h1><div className="pub-sub">{subtitle}</div></div>
      <div className="pub-fresh">{freshness}</div>
    </div></header>
    <main className="pub-page">{children}</main>
  </div>;
}

export function Card({title,subtitle,action,children}){
  return <section className="pub-card"><div className="pub-head"><div><h2>{title}</h2>{subtitle&&<div className="pub-muted">{subtitle}</div>}</div>{action}</div><div className="pub-body">{children}</div></section>;
}
